export enum DateDisplayType {
  Date,
  Time,
  TimeWithoutSeconds,
  DateTime,
  DateTimeWithoutSeconds,
  DateForFile
}
